<template>
  <div class="preview">
    <div class="image" :class="{ 'loaded': previewLoaded }" v-if="fileBlob">
      <nx-badge v-show="previewBadge" class="metas-badge ma-3">{{ previewBadge }}</nx-badge>
      <video v-if="fileIsVideo"
             @load='onPreviewLoad' ref="previewImg" width="100%" autoplay loop muted>
        <source :src="fileBlob" type="video/mp4"/>
      </video>
      <img v-if="fileIsImage" ref="previewImg" @load='onPreviewLoad' :src="fileBlob">
      <div class="nx-image-focal-point-preview" v-if="internalFocalPoint"
           :style="{ top: `${internalFocalPoint.top}%`, left: `${internalFocalPoint.left}%` }">
        <v-icon medium color="white">adjust</v-icon>
      </div>
    </div>
    <div class="placeholder grey lighten-3 grey--text" v-if="showDropzone">
      <p>{{ $t('message.upload.drophere') }}</p>
    </div>
  </div>
</template>

<script>
import NxBadge from '@/components/Badge';
import filesize from '@/plugins/filesize';

export default {
  name: 'nx-file-upload-preview',
  components: { NxBadge },
  props: {
    file: {
      type: File,
    },
    dropzone: {
      type: Boolean,
    },
    internalFocalPoint: {
      type: Object,
    },
  },
  data() {
    return {
      previewBadge: null,
      previewLoaded: false,
    };
  },
  computed: {
    fileBlob() {
      if (!this.file) return null;
      return URL.createObjectURL(this.file);
    },
    fileType() {
      if (!this.file) return null;
      return this.file.type;
    },
    fileIsImage() {
      return this.fileType && this.fileType.startsWith('image');
    },
    fileIsVideo() {
      return this.fileType && this.fileType.startsWith('video');
    },
    showDropzone() {
      if (!this.dropzone) {
        return false;
      }
      return !this.file;
    },
  },
  methods: {
    onPreviewLoad() {
      this.previewLoaded = true;
      const image = this.$refs.previewImg;
      if (!image) {
        return;
      }
      const size = filesize(this.file.size, { exponent: 2 });
      this.previewBadge = `${image.naturalWidth}x${image.naturalHeight} - ${size}`;

      this.$emit('preview:load', image);
    },
  },
};
</script>

<style lang="stylus" scoped>
.preview {
  .placeholder {
    display: flex;
    padding-top: 56.25%; /* 16:9 Aspect Ratio */
    align-items: center;
    align-content: center;
    justify-content: center;

    p {
      position: relative;
      margin-top: -56.25%;
    }
  }

  .image {
    position: relative;

    .metas-badge {
      position: absolute;
    }

    img {
      width: 100%
      opacity: 0
      transition: opacity 0.3s
    }

    &.loaded img {
      opacity: 1
    }

  }
}
</style >
